import { useState } from "react";
import { Icon } from "@duncancooper/brand";
import {
  useTheme,
  THEMES,
  DARK_TEXT,
  LIGHT_TEXT,
} from "../state/themeState.js";
import styles from "../styles/components/AboutPanel.module.css";

export function AboutPanel() {
  const { themeIndex, isDark } = useTheme();
  const colors = THEMES[themeIndex]![isDark ? "dark" : "light"];
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackSending, setFeedbackSending] = useState(false);
  const [feedbackSent, setFeedbackSent] = useState(false);

  return (
    <div className={styles.content}>
      <p>
        Twice Daily is a personal news digest with curated feeds, best consumed
        twice a day.
      </p>
      <br />
      <p>
        Developed by: <br />
        <a
          href="https://tuit.dev"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          <Icon
            separation={5}
            backgroundColor={colors.background}
            accentColor={colors.primary}
            textColor={isDark ? DARK_TEXT : LIGHT_TEXT}
          />{" "}
          &copy; {new Date().getFullYear()}
        </a>
        <br />
        <a
          href="https://tuit.dev"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btn}
        >
          Visit our website
        </a>{" "}
        <button
          type="button"
          className={`${styles.btn} ${feedbackOpen ? styles.btnActive : ""}`}
          onClick={() => setFeedbackOpen((v) => !v)}
        >
          Leave us feedback!
        </button>
      </p>
      {feedbackOpen && (
        <div className={styles.feedbackForm}>
          {feedbackSent ? (
            <p className={styles.feedbackThanks}>
              Thank you! We read every piece of feedback!
            </p>
          ) : (
            <>
              <textarea
                className={styles.feedbackInput}
                placeholder="Your feedback…"
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
                rows={3}
              />
              <button
                type="button"
                className={styles.feedbackSend}
                disabled={feedbackSending || !feedbackText.trim()}
                onClick={async () => {
                  setFeedbackSending(true);
                  try {
                    await fetch("/api/feedback", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({ text: feedbackText }),
                    });
                    setFeedbackSent(true);
                    setFeedbackText("");
                  } finally {
                    setFeedbackSending(false);
                  }
                }}
              >
                {feedbackSending ? "Sending…" : "Send"}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
